import { Box } from "@mui/material";

import DashboardHome from "./home/DashboardHome";
import MyFootprint from "./footprint/MyFootprint";
import SuppliersTab from "./collections/SuppliersTab";
import ProductsTab from "./collections/ProductsTab";
import CustomersTab from "./collections/CustomersTab";
import AgentActivityTab from "./tabs/AgentActivityTab";

const DashboardCanvas = ({
  activeTab,
  surfaceContext,
  surveyEmissions,
  nextBestAction,
  topSupplierEmissions,
  totalSurveyTons,
  surveySupplierCount,
  scopePieSeries,
  hotspots,
  offices,
  pdfReportDownload,
  customers
}) => {
  if (activeTab === "dashboard") {
    return (
      <DashboardHome
        surfaceContext={surfaceContext}
        surveyEmissions={surveyEmissions}
        nextBestAction={nextBestAction}
        topSupplierEmissions={topSupplierEmissions}
        totalSurveyTons={totalSurveyTons}
        surveySupplierCount={surveySupplierCount}
      />
    );
  }

  if (activeTab === "footprint") {
    return (
      <MyFootprint
        year={surfaceContext?.year}
        totalTons={surfaceContext?.totalTons}
        surveyEmissions={surveyEmissions}
        scopePieSeries={scopePieSeries}
        hotspots={hotspots}
        offices={offices}
        surveyStatus={surfaceContext?.surveyStatus}
        pdfReportDownload={pdfReportDownload}
      />
    );
  }

  if (activeTab === "suppliers") {
    return <SuppliersTab />;
  }

  if (activeTab === "products") {
    return <ProductsTab />;
  }

  if (activeTab === "customers") {
    return <CustomersTab customers={customers} />;
  }

  if (activeTab === "agent-activity") {
    return <AgentActivityTab />;
  }

  return <Box sx={{ minWidth: 0 }} />;
};

export default DashboardCanvas;
